/**
 Use to translate product name, variant name and interval from subscription json and reconstruct the object. Returns new object translated.
 * @param result
 * @param shopifyProducts
 * @returns {any}
 */
const translateSubJson = (result, shopifyProducts) =>{
    return Object.assign({}, result, {
        data: result.data.map((order) => {
            return Object.assign({
                ...order,
                items: {
                    ...order.items,
                    data: order.items.data.map((item) => {
                        const translatedProduct = shopifyProducts.find(
                            (prod) => prod.handle === item.product_slug
                        );
                        if (!translatedProduct) return { ...item };
                        const variantTitle = translatedProduct.variants.find(
                            (v) => v.id === parseInt(item.shopify_id)
                        );
                        return {
                            ...item,
                            title: translatedProduct && translatedProduct.title,
                            variant_title: variantTitle && variantTitle.title,
                        };
                    }),
                },
                interval: theme.translations.account_system[order.interval],
            });
        }),
    });
}